export default __webpack_public_path__ + "static/fisheries-979288cfa633f3880681dc4eeec0cfa4.png";